import type { ComponentType, ReactNode } from 'react'
import type { SDIconProps } from '@/shared/icons/SDIcon'
import { PulseTabIconSlot, PulseTabLabelFrame } from '../styled-components'

interface PulseTabLabelProps {
  Icon: ComponentType<SDIconProps>
  active: boolean
  children: ReactNode
}

const PulseTabLabel = ({ Icon, active, children }: PulseTabLabelProps) => (
  <PulseTabLabelFrame>
    <PulseTabIconSlot aria-hidden='true' $active={active}>
      <Icon size={16} color='currentColor' />
    </PulseTabIconSlot>
    {children}
  </PulseTabLabelFrame>
)

export default PulseTabLabel
